import { FlightSubLOBProps } from "components/flexComponents/WizardFlightPWA/typings";
import * as React from "react";
import { observer } from "mobx-react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { FlightsFareCalendar } from "./FlightsFareCalendar";
import {
  UitkLayoutGrid,
  UitkLayoutConditionalGridSpan,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { LobErrorSummary } from "src/components/shared/LobErrorSummary/LobErrorSummary";
import { SubmitButton } from "src/components/shared/SubmitButton/SubmitButton";
import { getShoppingGlobalMicroMessage } from "src/components/shared/StorefrontWizard/SubmitRow/UISShoppingGlobal";

export const StickyOnewayFlight = observer((props: FlightSubLOBProps) => {
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 2, medium: 12 };
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 6 };
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const submitColSpan: UitkLayoutConditionalGridSpan = { small: 4, medium: 2 };
  const fareCalendarTest = "PWA_fare_calendar_home_page";
  const uisShoppingGlobal = getShoppingGlobalMicroMessage(props.lobState);
  const {
    errorInputRef,
    isOnewayFormValid,
    numberOfErrors,
    moreThanOneError,
    updateInvalidFormsState,
  } = props.lobState;

  if (isOnewayFormValid) {
    updateInvalidFormsState();
  }

  return (
    <UitkLayoutGrid columns={mainGridColumns} space="three" className="all-t-margin-two">
      {!isOnewayFormValid && (
        <LobErrorSummary
          locHeadingToken={props.getLocError(false)!}
          locHeadingArgs={moreThanOneError() && [numberOfErrors]}
          locLinkToken={props.getLocError(true)}
          linkClickFocusId="roundtrip-error"
          inputErrorRef={errorInputRef}
          colSpan={mainGridColumns}
          setInputsRefs={props.setInputsRefs}
        />
      )}
      <Location
        setInputsRefs={props.setInputsRefs}
        originField
        destinationField
        lobState={props.lobState}
        showSwapLocationsControl
        colSpan={locationColSpan}
      />
      <Experiment name={fareCalendarTest}>
        <ExperimentControl>
          <Dates singleDate lobState={props.lobState} colSpan={datesColSpan} setInputsRefs={props.setInputsRefs} />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <FlightsFareCalendar
            singleDate
            lobState={props.lobState}
            colSpan={datesColSpan}
            setInputsRefs={props.setInputsRefs}
          />
        </ExperimentVariant>
      </Experiment>
      <SubmitButton
        lobState={props.lobState}
        colSpan={submitColSpan}
        rfrr={props.flightConfig.referrerId}
        uisPrimeMicroMessages={uisShoppingGlobal}
      />
    </UitkLayoutGrid>
  );
});
